"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictStaffSerializer = void 0;
var models_1 = require("../../models");
/**
 * Serializes district staff
 *
 * @author yogesh.bharambe
 */
var DistrictStaffSerializer = /** @class */ (function () {
    function DistrictStaffSerializer() {
    }
    DistrictStaffSerializer.prototype.serialize = function (_a) {
        var id = _a.id, firstName = _a.firstName, lastName = _a.lastName, districtId = _a.districtId, roles = _a.roles, schoolAdmin = _a.schoolAdmin, teacher = _a.teacher;
        return new models_1.DistrictStaff({
            id: id,
            firstName: firstName,
            lastName: lastName,
            districtId: districtId,
            roles: roles,
            schoolAdmin: schoolAdmin,
            teacher: teacher,
        });
    };
    return DistrictStaffSerializer;
}());
exports.DistrictStaffSerializer = DistrictStaffSerializer;
